/**
 * Get blob file and download
 * @param {Blob} data
 * @param {String} filename
 */
export function downloadPDF(data, filename) {
  const dataFile = new Blob([data], { type: 'application/pdf;base64' });
  const tempLink = document.createElement('a');
  tempLink.href = window.URL.createObjectURL(dataFile);
  tempLink.setAttribute('download', `cte_${filename}.pdf`);
  tempLink.click();
}

export function getDataDocumento(text) {
  if (!text) return;
  return text.replace('Disponibilizado em ', '');
}
